export const typeList = [
    {
        value: 0,
        label: '广告文案创作'
    },
    {
        value: 1,
        label: '数字人'
    },
    {
        value: 2,
        label: '广告图片创作'
    },
    {
        value: 3,
        label: 'AI助手'
    },
    {
        value: 4,
        label: '其他'
    }
];